import { render, staticRenderFns } from "./BlockedSuppliersSection.vue?vue&type=template&id=c339ef1c&scoped=true&"
import script from "./BlockedSuppliersSection.vue?vue&type=script&lang=js&"
export * from "./BlockedSuppliersSection.vue?vue&type=script&lang=js&"
import style0 from "./BlockedSuppliersSection.vue?vue&type=style&index=0&id=c339ef1c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c339ef1c",
  null
  
)

export default component.exports